import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Compass, Target, Sparkles, Building2, CheckCircle2, ArrowRight } from "lucide-react";

export const About = () => {
  return (
    <div className="min-h-screen bg-[#F9FBFF] text-[#091F5C] py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto space-y-16">
        
        {/* Header / Manifesto Hero */}
        <div className="text-center space-y-4">
          <span className="text-xs font-bold text-[#334DAF] uppercase tracking-widest font-heading">
            The FIND LET Manifesto
          </span>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-[#091F5C] font-heading tracking-tight leading-tight">
            London Lettings Are Broken. <br />
            <span className="text-[#334DAF]">We Put Verified Demand First.</span>
          </h1>
          <p className="text-[#4A5B78] text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
            Property search has devolved into clicking through hundreds of outdated portal listings, competing in chaotic bidding wars, and receiving irrelevant broker calls. We built FIND LET to restore sanity to London rentals.
          </p>
        </div>

        {/* The 3 Core Pillars */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-2xl border border-[#E5EBF5] shadow-sm space-y-3">
            <div className="w-12 h-12 rounded-xl bg-[#D0E4FE] text-[#334DAF] flex items-center justify-center font-bold">
              <Target className="w-6 h-6" />
            </div>
            <h3 className="text-xl font-bold text-[#091F5C] font-heading">Demand-Driven Match</h3>
            <p className="text-[#4A5B78] text-sm leading-relaxed">
              Instead of endless browsing, renters declare their exact criteria once. Landlords and property partners come directly to them.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl border border-[#E5EBF5] shadow-sm space-y-3">
            <div className="w-12 h-12 rounded-xl bg-[#D0E4FE] text-[#334DAF] flex items-center justify-center font-bold">
              <ShieldCheck className="w-6 h-6" />
            </div>
            <h3 className="text-xl font-bold text-[#091F5C] font-heading">100% Verified Inventory</h3>
            <p className="text-[#4A5B78] text-sm leading-relaxed">
              Every property is vetted for genuine availability, accurate photography, transparent deposits, and legal compliance before entering our active pool.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl border border-[#E5EBF5] shadow-sm space-y-3">
            <div className="w-12 h-12 rounded-xl bg-[#D0E4FE] text-[#334DAF] flex items-center justify-center font-bold">
              <Compass className="w-6 h-6" />
            </div>
            <h3 className="text-xl font-bold text-[#091F5C] font-heading">Human Concierge Desk</h3>
            <p className="text-[#4A5B78] text-sm leading-relaxed">
              We combine intelligent pairing workflows with seasoned London property operators who coordinate viewings, negotiations, and turnkey relocation.
            </p>
          </div>
        </div>

        {/* Narrative Section */}
        <div className="bg-white p-8 sm:p-12 rounded-3xl border border-[#E5EBF5] shadow-lg space-y-6">
          <h2 className="text-2xl font-bold text-[#091F5C] font-heading">
            A Better Standard for London Real Estate
          </h2>
          <div className="space-y-4 text-[#4A5B78] text-sm leading-relaxed">
            <p>
              London is one of the world's most competitive rental markets. Yet the tools used by renters and landlords haven't evolved in twenty years. Portals are incentivized by page views and lead spam rather than successful tenancies.
            </p>
            <p>
              FIND LET was founded by London property veterans and software architects to eliminate the noise. By structuring renter criteria upfront into precise search briefs, we give landlords qualified applicants with zero void periods, and we give renters private access to prime properties before they reach general public portals.
            </p>
            <p>
              With our integrated <strong>FIND LET Move</strong> service, we support the entire relocation lifecycle—from white-glove removals and deep cleaning to energy setups and bespoke furnishing.
            </p>
          </div>

          <div className="pt-6 border-t border-slate-100 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="text-xs text-[#4A5B78]">
              Registered in England & Wales • Mayfair Desk, London W1K
            </div>
            <div className="flex gap-3">
              <Link to="/find" className="px-5 py-2.5 rounded-xl bg-[#091F5C] hover:bg-[#061745] text-white font-semibold text-xs">
                Submit Renter Brief
              </Link>
              <Link to="/let" className="px-5 py-2.5 rounded-xl bg-[#091F5C] hover:bg-slate-700 text-white font-semibold text-xs">
                List Property
              </Link>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
